
export function getButtons (slot) {
  const buttons = document.createElement('div')

  const closeButton = document.createElement('div')
  const smrtbButton = document.createElement('a')

  // make the actual x button
  const x1 = document.createElement('span')
  const x2 = document.createElement('span')
  const xStyle = `height: 2px; width: 70%; position:absolute; top: 50%; 
    left: 15%; background-color: #FFF; margin-top: -1px;`
  x1.setAttribute('style', xStyle + 'transform: rotate(45deg)')
  x2.setAttribute('style', xStyle + 'transform: rotate(-45deg)')
  closeButton.appendChild(x1)
  closeButton.appendChild(x2)
  closeButton.onclick = function () {
    slot.destroy()
  }

  smrtbButton.href = 'https://smrtb.com/'
  smrtbButton.target = '_blank'
  const logo = document.createElement('img')
  logo.src = 'https://assets.website-files.com/5af333957d0ca73f66a0ff46/5b917b009721fd1811e3968d_smrtb-favicon-01.png'
  logo.style['max-width'] = '80%'
  logo.style['align-self'] = 'center'
  smrtbButton.appendChild(logo)

  const buttonList = [smrtbButton, closeButton]
  buttonList.forEach(function (button) {
    button.setAttribute('style', `cursor: pointer; display: inline-flex; position: relative; 
    margin: 0 2px; vertical-align: top; transition: all 200ms ease-in-out; justify-content: center; align-content: center;
    width: 20px; height: 20px; border-radius: 50%; background-color: black;
    -webkit-perspective: 1000; z-index: 1000; text-align: center;`)
    button.setAttribute('onmouseover', "this.style.transform='scale(1.1)'")
    button.setAttribute('onmouseout', "this.style.transform='none'")
    buttons.appendChild(button)
  })

  buttons.setAttribute('style', 'position: absolute; top: 2px; right: 5px;')

  setTimeout(() => {
    slot.node().appendChild(buttons)
  }, 250)
}
